import { Box, Grid, Tooltip, Typography } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as FilterIcon } from "../../../src/assets/Customer/FilterIcon.svg";
import { ReactComponent as FilterIconHover } from "../../../src/assets/Customer/FilterIconHover.svg";
import CustomTextfield from "../../components/CustomInputs/CustomTextfield";
import DialogBox from "../../components/DialogBoxComponent/DialogBox";
import Toast from "../../components/ToastContainer/CustomToast";
import { ThemeContext } from "../../theme/ThemeContext";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  input: {
    "&:-webkit-autofill": {
      WebkitTextFillColor: "#000 !important",
    },
  },
  dialogbox: {
    "& .MuiDialog-paper": {
      // minWidth: '110vh',
      maxWidth: "600px",
      // marginLeft: "250px",
      borderRadius: "20px",
      backgroundColor: (props) => (props.darkMode ? "#0E2A41" : "#fff"),
    },
  },
}));

export default function ChecklistFilterForm(props) {
  const [open, setOpen] = React.useState(false);
  const { t } = useTranslation();
  const [data, setData] = useState();
  const [purposeIcon, setPurposeIcon] = React.useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const { darkMode, setDiaLogBoxBlur } = useContext(ThemeContext);
  const classes = useStyles({ darkMode });
  const [payload, setPayload] = useState({
    name: "",
    code: "",
    description: "",
  });

  const handleClose = () => {
    setPayload({
      name: "",
      code: "",
      description: "",
    });
    setOpen(false);
    setDiaLogBoxBlur(false);
  };

  const [error, setError] = useState({
    name: false,
    code: false,
    description: false,
  });

  if (open) {
    setDiaLogBoxBlur(true);
  }

  const handleChange = (event) => {
    const name = event.target.name;
    setPayload({
      ...payload,
      [name]: event.target.value,
    });

    setError({
      [name]: false,
    });
  };

  const handleSubmit = () => {
    if (
      payload.name.trim() === "" &&
      payload.code.trim() === "" &&
      payload.description.trim() === ""
    ) {
      Toast(t("COMMON154"), "error");
      return;
    }

    props.applyFilter(payload);
    setPayload({
      name: "",
      code: "",
      description: "",
    });
    handleClose();
  };
  useEffect(() => {}, []);

  return (
    <>
      <Tooltip
        title={
          <Typography fontSize={12} fontWeight={500}>
            {t("COMMON006")}
          </Typography>
        }
      >
        <span
          className={darkMode ? "filterdark" : "filter"}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onClick={() => setOpen(true)}
        >
          {isHovered ? (
            <FilterIconHover
              style={{
                cursor: "pointer",
                color: darkMode ? "#fff" : "#474a4e",
              }}
            >
              <ChecklistFilterForm />
            </FilterIconHover>
          ) : (
            <FilterIcon
              style={{
                cursor: "pointer",
                color: darkMode ? "#fff" : "#474a4e",
              }}
            >
              <ChecklistFilterForm />
            </FilterIcon>
          )}
        </span>
      </Tooltip>
      <DialogBox
        Header={
          <span
            style={{ fontSize: "21px", color: darkMode ? "#fff" : "black" }}
          >
            {t("COMMON006")}
          </span>
        }
        className={classes.dialogbox}
        acceptText={t("COMMON024")}
        cancelText={t("COMMON008")}
        fullWidth={true}
        open={open}
        onClose={handleClose}
        onSubmit={handleSubmit}
        cancel={handleClose}
      >
        <Grid
          container
          rowSpacing={2}
          style={{ backgroundColor: darkMode ? "#0E2A41" : "#fff" }}
        >
          <Grid item xs={12} sm={12}>
            <CustomTextfield
              label={t("COMMON014")}
              error={error.name}
              name="name"
              value={payload.name}
              handleChange={(e) => handleChange(e)}
              helperText={error.name}
            />
          </Grid>
        </Grid>
      </DialogBox>
    </>
  );
}
